import { render } from "./pointList.vue?vue&type=template&id=3e7d37c8&scoped=true"
import script from "./pointList.vue?vue&type=script&lang=js"
export * from "./pointList.vue?vue&type=script&lang=js"

import "./pointList.vue?vue&type=style&index=0&id=3e7d37c8&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7d37c8"]])

export default __exports__